/* tslint:disable */
/* eslint-disable */
export enum WorkDataQualityDateFixAction {
  Swap = 'swap',
  SetEndToStart = 'set-end-to-start',
  SetStartToEnd = 'set-start-to-end',
  ZeroTimes = 'zero-times'
}
